import { v4 as uuidv4 } from "uuid";
import { getSizingOptions } from "@/react/components/shared/BuilderUI/utils/sizeStyleHelpers";
import { defaultData as defaultPData } from "@/react/components/shared/Emails/VisualEmailBuilder/Blocks/Content/PBlock/P1BlockDefaultData";
import type { BaseBlock } from "@circle-react-shared/BuilderUI/DataModel.types";
import { createImageBlock } from "@circle-react-shared/BuilderUI/DefaultBlocks/utils/mediaBlockHelpers";
import {
  createH1Block,
  createPBlock,
} from "@circle-react-shared/BuilderUI/DefaultBlocks/utils/textBlocksHelpers";
import { getBackgroundImageOptions } from "@circle-react-shared/BuilderUI/utils/backgroundHelpers";
import {
  getMarginOptions,
  getPaddingOptions,
} from "@circle-react-shared/BuilderUI/utils/boxModelStyleHelpers";
import { getBackgroundColorOptions } from "@circle-react-shared/BuilderUI/utils/buttonStyleHelpers";
import { getBorderRadiusOptions } from "@circle-react-shared/BuilderUI/utils/imgStyleHelpers";
import { defaultData as defaultImageData } from "@circle-react-shared/Emails/VisualEmailBuilder/Blocks/Content/ImgBlock/ImgBlockDefaultData";
import placeholderImage from "@circle-react-shared/Emails/VisualEmailBuilder/Blocks/Content/ImgBlock/img_preview_large.png";
import { createButtonBlock } from "@circle-react-shared/Emails/VisualEmailBuilder/Blocks/Content/createButtonBlock";
import { defaultData as defaultH1Data } from "@circle-react-shared/Emails/VisualEmailBuilder/Blocks/Headings/H1Block/H1BlockDefaultData";
import { getAlignmentOptions } from "../../../Utils/buttonStyleHelpers";
import { defaultStyles } from "./defaultStyles";

export const defaultData: BaseBlock = {
  id: uuidv4(),
  type: "HeroBlock2",
  props: {
    headerContent: {
      prop: "children",
      type: "children",
      value: [
        createH1Block({
          text: "Heading",
          baseData: defaultH1Data,
          styles: {
            margin: getMarginOptions({
              defaultValue: {
                marginTop: "12",
                marginBottom: "12",
                marginLeft: "24",
                marginRight: "24",
              },
            }),
            padding: getPaddingOptions({
              defaultValue: {
                paddingTop: "0",
                paddingBottom: "0",
                paddingLeft: "0",
                paddingRight: "0",
              },
            }),
          },
        }),
        createPBlock({
          text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse varius enim in eros elementum tristique.",
          baseData: defaultPData,
          styles: {
            margin: getMarginOptions({
              defaultValue: {
                marginTop: "12",
                marginBottom: "12",
                marginLeft: "24",
                marginRight: "24",
              },
            }),
            padding: getPaddingOptions({
              defaultValue: {
                paddingTop: "0",
                paddingBottom: "0",
                paddingLeft: "0",
                paddingRight: "0",
              },
            }),
          },
        }),
      ],
    },
    primaryButton: {
      prop: "children",
      type: "children",
      value: [
        createButtonBlock({
          text: "Button",
          href: "#",
          buttonType: "primaryButton",
          styles: {
            alignment: getAlignmentOptions("left"),
            margin: getMarginOptions({
              defaultValue: {
                marginTop: "12",
                marginBottom: "12",
                marginLeft: "24",
                marginRight: "24",
              },
            }),
          },
        }),
      ],
    },
    imageContent: {
      prop: "children",
      type: "children",
      value: [
        createImageBlock({
          signedId: "",
          placeholder: placeholderImage,
          baseData: defaultImageData,
          styles: {
            sizing: getSizingOptions({
              defaultValue: {
                width: "100%",
                height: "264px",
                minWidth: "100px",
                minHeight: "100px",
                maxWidth: "100%",
                maxHeight: "auto",
              },
            }),
            margin: getMarginOptions({
              defaultValue: {
                marginTop: "12",
                marginBottom: "12",
                marginLeft: "24",
                marginRight: "24",
              },
            }),
            borderRadius: getBorderRadiusOptions({
              defaultValue: {
                border_left_top_radius: 12,
                border_left_bottom_radius: 12,
                border_right_top_radius: 12,
                border_right_bottom_radius: 12,
              },
            }),
          },
        }),
      ],
    },
    styles: {
      prop: "styles",
      type: "styles",
      value: {
        backgroundColor: getBackgroundColorOptions({
          defaultValue: defaultStyles.backgroundColor,
        }),
        backgroundImage: getBackgroundImageOptions(),
        padding: getPaddingOptions({
          defaultValue: defaultStyles.padding,
        }),
        margin: getMarginOptions({
          defaultValue: defaultStyles.margin,
        }),
      },
    },
  },
};
